(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3154],{

/***/ 27484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 93573:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-scenarios/[slug]/latest-run",
      function () {
        return __webpack_require__(77573);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30453);


const Loading = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-2/3 flex flex-col",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            width: "40",
            className: "flex-1 m-auto mt-6 animate-spin"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 30453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Spinner = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 100 100",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M90.9 58.2c-3.8 18.9-20.1 32.7-39.7 33-22 .4-40.7-17-41.9-39C8 28.5 26.9 8.8 50.4 8.8c19 0 35.5 13.1 40 31.2.3 1.2 1.4 2.1 2.7 2.1 1.8 0 3.1-1.7 2.7-3.5C90.6 18.1 72 3.3 50.4 3.3c-27.2 0-49 23.4-46.6 51.1 2.1 23 21 41.2 44 42.4C71.6 98 91.7 81.9 96.2 59.4c.3-1.7-1-3.3-2.7-3.3-1.3-.1-2.4.8-2.6 2.1z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 16755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useRequireAuth; }
/* harmony export */ });
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18424);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const useRequireAuth = function() {
    let redirectUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/login";
    const auth = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .a)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // If auth.user is false that means we're not
    // logged in and should redirect.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const timed = setTimeout(()=>{
            if (!auth.user) {
                router.push(`${redirectUrl}?returnTo=${router.asPath}`);
            }
        }, 300);
        return ()=>clearTimeout(timed);
    }, [
        auth,
        redirectUrl,
        router
    ]);
    return auth;
};


/***/ }),

/***/ 84501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ TimeAggregationLevels; }
/* harmony export */ });
var TimeAggregationLevels;
(function(TimeAggregationLevels) {
    TimeAggregationLevels["fiveSecond"] = "5s";
    TimeAggregationLevels["thirtySecond"] = "30s";
    TimeAggregationLevels["oneMinute"] = "1m";
    TimeAggregationLevels["fiveMinute"] = "5m";
    TimeAggregationLevels["thirtyMinute"] = "30m";
})(TimeAggregationLevels || (TimeAggregationLevels = {}));


/***/ }),

/***/ 77573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_dashboard_charts_Loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7268);
/* harmony import */ var components_dashboard_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59319);
/* harmony import */ var hooks_useRequireAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16755);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var services_testRun__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67111);







const getTestScenarioId = (query)=>{
    return query.slug;
};
const LatestRunPage = ()=>{
    const { user  } = (0,hooks_useRequireAuth__WEBPACK_IMPORTED_MODULE_3__/* .useRequireAuth */ .Q)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const testScenarioId = getTestScenarioId(router.query);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        if (user?.readToken) {
            (0,services_testRun__WEBPACK_IMPORTED_MODULE_6__/* .getRecentTestRunSummaries */ ._O)(user.readToken, 1, 0, testScenarioId).then((testRunSummaries)=>{
                if (testRunSummaries.length > 0) {
                    router.push(`/test-runs/${testRunSummaries[0].runId}`);
                } else {
                    router.push(`/test-runs/unknown`);
                }
            }).catch((err)=>console.error("Error fetching latest test run", err));
        }
    }, [
        user?.readToken,
        router,
        testScenarioId
    ]);
    if (!user) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dashboard_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dashboard_charts_Loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LatestRunPage);


/***/ }),

/***/ 67111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JW": function() { return /* binding */ tryGetTestRunCharts; },
/* harmony export */   "X_": function() { return /* binding */ getTestRunSummary; },
/* harmony export */   "Yw": function() { return /* binding */ getOperationsByScenario; },
/* harmony export */   "Zh": function() { return /* binding */ tryGetTestRunOperations; },
/* harmony export */   "_O": function() { return /* binding */ getRecentTestRunSummaries; },
/* harmony export */   "bh": function() { return /* binding */ getTestRun; },
/* harmony export */   "eo": function() { return /* binding */ tryGetTestRunSummary; },
/* harmony export */   "vj": function() { return /* binding */ getPopularTestScenarios; }
/* harmony export */ });
/* unused harmony exports getTestRunSummaryRaw, getTestRunOperationsRaw, getTestRunOperations, getTestRunChartsRaw, getTestRunCharts */
/* harmony import */ var _supabase_supabase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30218);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84501);



const supabase = (0,_supabase_supabase_js__WEBPACK_IMPORTED_MODULE_2__/* .createClient */ .eI)("https://cugddtipnsjmjfmrxbsn.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN1Z2RkdGlwbnNqbWpmbXJ4YnNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTYzNzI1NDEsImV4cCI6MTk3MTk0ODU0MX0.ZiOxh9HYAwmSpbxMk5qNZoHoIiimadsawg6KlWkbPy4");
const getTestRun = async (token, testRunId)=>{
    supabase.auth.setAuth(token);
    const { data , error  } = await supabase.from("perf_test_runs").select("id,name,testScenarioId:test_scenario_id,publishStrategy:publish_strategy,startedAt:started_at,stoppedAt:stopped_at,createdAt:created_at").eq("id", testRunId);
    if (error || !data || data.length === 0) {
        throw error;
    }
    return data[0];
};
const shouldGetRawValues = (testRun)=>{
    return testRun.publishStrategy === "listener" && (!testRun.stoppedAt || dayjs__WEBPACK_IMPORTED_MODULE_0___default()().valueOf() - 60 * 1000 < dayjs__WEBPACK_IMPORTED_MODULE_0___default()(testRun.stoppedAt).valueOf());
};
const tryGetTestRunSummary = async (token, testRun, operationNames)=>{
    if (shouldGetRawValues(testRun)) {
        return getTestRunSummaryRaw(token, testRun.id, operationNames);
    } else {
        return getTestRunSummary(token, testRun.id, operationNames);
    }
};
const getTestRunSummaryRaw = async (token, testRunId, operationNames)=>{
    supabase.auth.setAuth(token);
    const operations = operationNames.length === 1 && operationNames[0] === "Overall" ? null : operationNames;
    const { data , error  } = await supabase.rpc("test_run_summaries_raw", {
        operations
    }).eq("runId", testRunId).order("requests", {
        ascending: false
    });
    if (error) {
        throw error;
    }
    return data.reduce((acc, curr)=>{
        acc[curr.operationName] = {
            id: testRunId,
            requestsPerSecond: parseFloat((curr.requests / (curr.stoppedAt - curr.startedAt)).toFixed(5)),
            failureRate: parseFloat((curr.failures / curr.requests).toFixed(5)),
            ...curr
        };
        return acc;
    }, {});
};
const getTestRunSummary = async (token, testRunId, operationNames)=>{
    supabase.auth.setAuth(token);
    const { data , error  } = await supabase.rpc("test_run_summaries").eq("runId", testRunId).in("operationName", operationNames).order("requests", {
        ascending: false
    });
    if (error) {
        throw error;
    }
    return data.reduce((acc, curr)=>{
        acc[curr.operationName] = {
            id: testRunId,
            requestsPerSecond: parseFloat((curr.requests / (curr.stoppedAt - curr.startedAt)).toFixed(5)),
            failureRate: parseFloat((curr.failures / curr.requests).toFixed(5)),
            ...curr
        };
        return acc;
    }, {});
};
const tryGetTestRunOperations = async (token, testRun)=>{
    if (shouldGetRawValues(testRun)) {
        return getTestRunOperationsRaw(token, testRun.id);
    } else {
        return getTestRunOperations(token, testRun.id);
    }
};
const getTestRunOperationsRaw = async (token, testRunId)=>{
    supabase.auth.setAuth(token);
    const { data , error  } = await supabase.rpc("test_run_operations_raw").eq("runId", testRunId);
    if (error) {
        throw error;
    }
    return data;
};
const getTestRunOperations = async (token, testRunId)=>{
    supabase.auth.setAuth(token);
    const { data , error  } = await supabase.rpc("get_test_run_operations", {
        run_id: testRunId
    });
    if (error) {
        throw error;
    }
    return data;
};
const getOperationsByScenario = async (token, testScenarioId)=>{
    supabase.auth.setAuth(token);
    const { data , error  } = await supabase.from("perf_test_operations").select("id,name").eq("test_scenario_id", testScenarioId);
    if (error) {
        throw error;
    }
    return data;
};
const tryGetTestRunCharts = async (token, testRun, operationNames, timeAggregationLevel)=>{
    if (testRun.publishStrategy === "listener") {
        return getTestRunChartsRaw(token, testRun.id, operationNames, timeAggregationLevel);
    } else {
        return getTestRunCharts(token, testRun.id, operationNames, timeAggregationLevel);
    }
};
const getTestRunChartsRaw = async (token, testRunId, operationNames, timeAggregationLevel)=>{
    supabase.auth.setAuth(token);
    const timeInterval = convertToTimeInterval(timeAggregationLevel);
    const operations = operationNames.length === 1 && operationNames[0] === "Overall" ? null : operationNames;
    const { data , error  } = await supabase.rpc("get_test_run_charts_v1", {
        run_id: testRunId,
        operations,
        time_interval: timeInterval
    });
    if (error) {
        throw error;
    }
    return data.reduce((acc, curr)=>{
        acc[curr.operationName] = {
            ...curr,
            requestsPerSecond: curr.timestamps.map((_, i)=>parseFloat((curr.requests[i] / convertToSeconds(timeAggregationLevel)).toFixed(5))),
            failureRate: curr.timestamps.map((_, i)=>parseFloat((curr.failures[i] / curr.requests[i]).toFixed(5)))
        };
        return acc;
    }, {});
};
const getTestRunCharts = async (token, testRunId, operationNames, timeAggregationLevel)=>{
    supabase.auth.setAuth(token);
    const { data , error  } = await supabase.rpc("get_test_run_charts", {
        run_id: testRunId,
        operations: operationNames,
        time_aggregation_level: timeAggregationLevel
    });
    if (error) {
        throw error;
    }
    return data.reduce((acc, curr)=>{
        acc[curr.operationName] = {
            ...curr,
            requestsPerSecond: curr.timestamps.map((_, i)=>parseFloat((curr.requests[i] / convertToSeconds(timeAggregationLevel)).toFixed(5))),
            failureRate: curr.timestamps.map((_, i)=>parseFloat((curr.failures[i] / curr.requests[i]).toFixed(5)))
        };
        return acc;
    }, {});
};
const getRecentTestRunSummaries = async function(token, limit, offset) {
    let scenarioId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, ascending = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    supabase.auth.setAuth(token);
    const query = supabase.rpc("test_run_summaries").eq("operationName", "Overall").order("stoppedAt", {
        ascending
    }).range(offset, offset + limit);
    if (scenarioId) {
        query.eq("scenarioId", scenarioId);
    }
    const { data , error  } = await query;
    if (error) {
        throw error;
    }
    return data.map((d)=>({
            ...d,
            requestsPerSecond: d.requests / (d.stoppedAt - d.startedAt),
            failureRate: d.failures / d.requests
        }));
};
const getPopularTestScenarios = async (token, limit, offset)=>{
    supabase.auth.setAuth(token);
    // TODO(bobsin): order this
    const { data , error  } = await supabase.rpc("test_scenarios").range(offset, offset + limit);
    if (error) {
        throw error;
    }
    return data;
};
const convertToTimeInterval = (timeAggregationLevel)=>{
    return ({
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.fiveSecond */ .Y.fiveSecond]: "5 seconds",
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.thirtySecond */ .Y.thirtySecond]: "30 seconds",
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.oneMinute */ .Y.oneMinute]: "1 minute",
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.fiveMinute */ .Y.fiveMinute]: "5 minutes",
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.thirtyMinute */ .Y.thirtyMinute]: "30 minutes"
    })[timeAggregationLevel];
};
const convertToSeconds = (timeAggregationLevel)=>{
    return ({
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.fiveSecond */ .Y.fiveSecond]: 5,
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.thirtySecond */ .Y.thirtySecond]: 30,
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.oneMinute */ .Y.oneMinute]: 60,
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.fiveMinute */ .Y.fiveMinute]: 300,
        [interfaces_testRun__WEBPACK_IMPORTED_MODULE_1__/* .TimeAggregationLevels.thirtyMinute */ .Y.thirtyMinute]: 1800
    })[timeAggregationLevel];
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,218,9319,9774,2888,179], function() { return __webpack_exec__(93573); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);